<template>
    <ion-list lines="none" :class="displayModeClass">
        <ion-item v-if="contact.name"> 
            {{ contact.name }}
        </ion-item>
        <ion-item v-if="contact.phone">
            <a class="external-link" target="_blank" :href="'tel:' + contact.phone">{{ contact.phone }}</a>
        </ion-item>
        <ion-item v-if="contact.mobile">
            <a class="external-link" target="_blank" :href="'tel:' + contact.mobile">{{ contact.mobile }}</a>
        </ion-item>
        <ion-item v-if="contact.mail">
            <a class="external-link" target="_blank" :href="'mailto:' + contact.mail">{{ contact.mail }}</a>
        </ion-item>
        <ion-item v-if="website">
            <a class="external-link" target="_blank" :href="website">{{ website }}</a>
        </ion-item>
    </ion-list>
</template>


<script setup lang="ts">
import {
    IonIcon,
    IonList,
    IonItem
} from '@ionic/vue';
import {Contact} from "@/graphql/generated/graphql";
import { callOutline, globeOutline, mailOpenOutline, personCircleOutline, phonePortraitOutline } from 'ionicons/icons';
import { computed } from 'vue';

const props = defineProps<{
        contact: Contact
        website?: string | undefined
        displayMode?: 'standalone' | 'inline' | undefined
    }>()

// this could be a prop default - if i'd be able to figure out how they work
const displayModeClass = computed(() =>  props.displayMode ||  'inline')
</script>

<style scoped>
.standalone ion-item {
    --min-height: var(--custom-font-size-regular);
    font-size: var(--custom-font-size-regular);
    color: var(--ion-color-medium);
}

.inline ion-item {
    --min-height: var(--custom-font-size-regular);
    font-size: var(--custom-font-size-regular);
    color: var(--ion-color-medium);
}
</style>
